module.exports = __webpack_public_path__ + "img/kort-8.a3d2fea8.jpg";